if (!customElements.get('mc-faq-item')) {
  customElements.define('mc-faq-item', class extends window.MCAnimatedDetails {
    connectedCallback() { this.connectDisclosure('.mc-faq__body', '.mc-faq__answer'); }
    disconnectedCallback() { this.disconnectDisclosure(); }
  });
}
if (!window.mcFaqGuideInstalled) {
  window.mcFaqGuideInstalled = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-mc-faq-size-guide]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const guide = link.closest('product-info')?.querySelector('mc-size-guide');
    if (!guide?._mcsgOpen) return;
    event.preventDefault(); guide._mcsgOpen();
  });
}
